import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/img/Make a deal.webm")